// extracted by mini-css-extract-plugin
export var calendarView = "_kv-0";